.container {
    display: flex;
    flex-direction: column;
    background-color: var(--bi-neutral-5);
    padding: var(--bi-scale-8x) var(--bi-scale-4x);
    border-bottom: 1px solid var(--bi-neutral-15);

    @media (width < 768px) {
        padding: 0 0 var(--bi-scale-8x) 0;
    }
}

.alertContainer {
    align-self: center;
    padding-top: var(--bi-scale-6x);
    max-width: 552px;
    font-size: 1rem;
}

.showOptionsContainer {
    margin-top: var(--bi-scale-8x);
    display: flex;
    justify-content: center;

    &:empty {
        display: none;
    }
}
